import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextField,
  SelectInput,
  required,
} from "react-admin";
import { EMAIL_SERVICES_STATUSES } from "@local/constants/index.js";
import { CustomToolbar, Title } from "../../shared/components/index.js";

const EmailServiceEdit = () => (
  <Edit
    redirect="list"
    title={<Title source="name" />}
    mutationMode="pessimistic"
  >
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextField source="name" />
      <SelectInput
        source="status"
        validate={[required()]}
        choices={Object.keys(EMAIL_SERVICES_STATUSES).map((status) => ({
          id: status,
          name: `resources.EmailService.source.status.${status}`,
        }))}
      />
    </SimpleForm>
  </Edit>
);

export default EmailServiceEdit;
